import React, {Component, forwardRef, useImperativeHandle, useRef} from 'react';
import {
    View,
    TouchableOpacity,


} from 'react-native';
import {moderateScale} from '../../../tools/Scaling';
import Colors from '../../../tools/Colors';
import HMIcon from '../../HMIcon';

// import AudioReactRecorder, {RecordState} from "../../record/audio/RecordAudio.web";
import HMTextView from '../../HMTextView';
import {Tools} from '../../../tools/Tools';
import {AudioRecorder, useAudioRecorder} from 'react-audio-voice-recorder';
import {connect} from 'react-redux';

// import AudioRecorder from "./2/components/AudioRecordingComponent";
// import useAudioRecorder from "./2/hooks/useAudioRecorder";

let descriptionValue = null;
let stream = null;
let container = null;
const audioType = 'audio/webm';
// const recorderControls = useAudioRecorder()
// const addAudioElement = (blob) => {
//     const url = URL.createObjectURL(blob);
//     const audio = document.createElement("audio");
//     audio.src = url;
//     audio.controls = true;
//     document.body.appendChild(audio);
// };
const addAudioElement = (blob) => {
    const url = URL.createObjectURL(blob);
    const audio = document.createElement('audio');
    audio.src = url;
    audio.controls = true;
    document.body.appendChild(audio);
};

class HMRecordAudio extends Component {
    constructor(props) {
        super(props);
        container = this;

        this.state = {
            min: null,
            max: null,
            size: null,
            visibleModal: '',
            index: 0,
            checked: false,
            pathCompress: null,

            currentTime: 0.0,
            playSeconds: 0.0,
            recording: false,
            paused: false,
            stoppedRecording: true,
            finished: false,
            //   audioPath: AudioUtils.DocumentDirectoryPath + '/' + new Date().getTime() + '.aac',
            //   audioPath: null,
            hasPermission: undefined,
            prepareRecord: true,


            playState: 'record', //playing, paused ,record , stop
            duration: 0,

            alaki: false,
            audioURL: null,
            showMessageInput: null,
            onPressStatusVoice: false,
            recordState: null,
            isLoading: false,

        };
        //this.recorderRef = React.createRef();

        this._refreshAudio = this._refreshAudio.bind(this);

        this.recorderRef = React.createRef();
    }


    //    if (container.state.recording)
    //             container.setState(
    //                 {
    //                     playState: 'record'
    //                 },
    //                 async () => {
    //                     await container._stopWeb()
    //                 }
    //             )

    componentWillReceiveProps(props) {


    }

    componentDidMount() {

        // BackHandler.addEventListener('hardwareBackPress', container.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', container.handleBackPress);
    }

    /*    async _recordWeb() {

            if (!stream) {

                stream = await navigator.mediaDevices.getUserMedia({audio: true});
                // show it to user
                // container.audio.src = window.URL.createObjectURL(stream);
                // container.audio.play();
                // init recording
                var options = {mimeType: 'audio/webm'};

                container.mediaRecorder = new MediaRecorder(stream, options);
                // init data storage for video chunks
                container.chunks = [];
                // listen for data from media recorder
                container.mediaRecorder.ondataavailable = e => {
                    if (e.data && e.data.size > 0) {
                        container.chunks.push(e.data);
                    }
                };
            }


            //e.preventDefault();
            // wipe old data chunks
            container.chunks = [];
            // start recorder with 10ms buffer
            container.mediaRecorder.start(10);
            // say that we're recording
            //container.setState({recording: true,playState:"record"});
            container.setState({recording: true, paused: false});
        }

        _stopWeb() {

            // e.preventDefault();
            // stop the recorder
            // console.log("container.state.currentTime",container.state.currentTime)
            container.mediaRecorder.stop();
            // say that we're not recording
            //  container.setState({recording: false,playState:"stop"});
            container.setState({stoppedRecording: true, recording: false, paused: false});
            // save the video to memory

            if (container.state.currentTime <= 0)
                return false;

            container.saveAudio();
        }

        saveAudio() {
            // convert saved chunks to blob
            const blob = new Blob(container.chunks, {type: audioType});
            // generate video url from blob
            //  const audioURL = window.URL.createObjectURL(blob);
            // append videoURL to list of saved videos for rendering
            // const audios = container.state.audios.concat([audioURL]);
            const audios = window.URL.createObjectURL(blob);
            Tools.copyClipboardWeb(audios);

            let obj1 = {durationVoice: container.state.currentTime};
            container.setState(obj1);
            container.props._setStateData?.(obj1);
            container.props._setStateDataParent?.(obj1);

            let obj2 = {
                audios, audioPath: audios, audioBlob: blob, ShowAudio: true,
                visibleModal: '', currentTime: 0
            }
            container.props._setStateData?.(obj2);
            container.props._setStateDataParent?.(obj2);

            container.setState(obj2,
                () => {
                    container.setData();
                }
            );

            stream.getTracks().forEach(function (track) {
                track.stop();
                stream = null;
            });

        }



        switchIcon() {
    //playing, paused ,record , stop
            switch (container.state.playState) {
                case 'record':

                    return PathFile.image.img_record
                case 'stop':

                    return PathFile.image.img_stop
                case 'playing':


                    return PathFile.image.img_play

                case 'paused':

                    return PathFile.image.img_pause

                default :

            }
        }


        switchOnPress(data) {
            switch (container.state.playState) {
                case 'record':
                    container.setState(
                        {
                            playState: 'stop'
                        },
                        () => {
                            container._recordWeb()
                        }
                    )
                    break;
                case 'stop':
                    container.setState(
                        {
                            playState: 'record'
                        },
                        async () => {
                            await container._stopWeb()
                        }
                    )
                    break;
                case 'playing':

                    container.setState(
                        {
                            playState: 'paused'
                        },
                        () => {
                            //   container._playWeb()
                        }
                    )
                    break;

                case 'paused':
                    container.setState(
                        {
                            playState: 'playing'
                        },
                        () => {
                            // container._pauseWeb()

                        }
                    )
                    break;


                default :

            }


        }
    */
    async _refreshAudio() {
        let obj = {
            ShowAudio: false,
            currentTime: 0.0,
            playSeconds: 0.0,
            recording: false,
            paused: false,
            stoppedRecording: true,
            finished: false,
            // audioPath: AudioUtils.DocumentDirectoryPath +'/' +new Date().getTime()+'.aac',
            //   audioPath: null,
            //    hasPermission: undefined,


            playState: 'record', //playing, paused ,record , stop
            duration: 0,

        };
        container.props._setStateData?.(obj);
        container.props._setStateDataParent?.(obj);
        container.setState(obj);

        //  container.props.func("audioPath", null)
        // container.props.func("ShowAudio", false)

    }

    render() {
        const {
            funcSwitch, onPress, styleRoot, style, text, numberOfLines, type, cammas, noFont, onValueChangeSelectInput,
            setStateData,
            itemExtra,
            resultsExtra,
            showTime,
            styleTime,
            styleIcon,
            fontSizeIcon,
            colorIcon,
            clearState,
            notFirstClear,
        } = container.props;

        return (
            <TouchableOpacity
                // ref={ref => {
                //     this.recorderRef.current = ref
                // }}
                activeOpacity={1}
                // onPress={() => {
                //     container.setState(
                //         {
                //             playState: 'record',
                //             visibleModal: "selectaudio",
                //             Modalcategory: true,
                //             showMessageInput: false,
                //         },
                //         () => {
                //             // container.onShow("selectaudio")
                //
                //             // container._playWeb()
                //
                //         }
                //     )
                //
                //
                // }}
                onPressIn={() => {
                    //   container.props.clearState();
                    clearState && !notFirstClear ? clearState() : null;
                    //container.startAudio()
                    container.setState({onPressStatusVoice: true});
                    // container.func_switchOnPress = container.switchOnPress();
                    container.func_switchOnPress = container.startAudio();
                    container.props._setStateData?.({currentTime: 0});
                    container.props._setStateDataParent?.({currentTime: 0});

                    container.setState({currentTime: 0},
                        () => {
                            container.timeout = setInterval(() => {

                                if (container.props.recorderControls.recordingTime === 0) {
                                    // if (container.state.currentTime === 0) {


                                }
                                if (container.props.recorderControls.recordingTime >= 60) {
                                    //  container.switchOnPress();
                                    container.stopAudio();
                                }
                                else {
                                    container.props._setStateData({currentTime: container.props.recorderControls.recordingTime + 1});
                                    container.props._setStateDataParent?.({currentTime: container.props.recorderControls.recordingTime + 1});
                                    container.setState({
                                        currentTime: container.props.recorderControls.recordingTime + 1,
                                    });
                                    /* container.props._setStateData({currentTime: container.state.currentTime + 1});
                                     container.props._setStateDataParent?.({currentTime: container.state.currentTime + 1});
                                     container.setState({
                                         currentTime: container.state.currentTime + 1
                                     })*/

                                }


                            }, 1000);
                        },
                    );

                }}
                onPressOut={() => {
                    container.setState({onPressStatusVoice: false});

                    container.func_switchOnPress && container.func_switchOnPress.remove();
                    if (container.timeout) {
                        clearInterval(container.timeout);
                    }

                    // if (container.state.playState !== "record" && container.mediaRecorder)
                    //     container.switchOnPress("onPressOut");

                    container.stopAudio();

                }}

                style={[{
                    // width:"100%",
                    // height: "100%",
                    // width: moderateScale(62),
                    // height: moderateScale(62),
                    //   backgroundColor: '#27eeee',
                    // width: moderateScale(48),
                    // height: moderateScale(48),
                    // backgroundColor: '#ee005b',
                    //position: 'absolute',
                    //  borderRadius: moderateScale(24),
                    margin: moderateScale(4),
                    //  top: 0,
                    //  left: 0,
                    alignItems: 'center',
                    justifyContent: 'center',

                    // alignSelf: "center",
                }, style]}>
                <View style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: .009,
                    overflow: 'hidden',
                }}>
                    {/*       <AudioReactRecorder state={this.state.recordState} onStop={this.onStopAudio}
                                        currentTime={this.state.currentTime}/>*/}


                    <AudioRecorder
                        ref={(ref) => {
                            this.recorderRef.current = ref;
                        }}
                        //  onRecordingComplete={(blob) => addAudioElement(blob)}
                        onRecordingComplete={this.onStopAudio}
                        recorderControls={this.props.recorderControls}
                    />
                </View>
                <HMIcon
                    // type={""}
                    name={'mic'}
                    style={[{
                        width: moderateScale(container.state.onPressStatusVoice ? 48 : (fontSizeIcon ? fontSizeIcon : 36)),
                        height: moderateScale(container.state.onPressStatusVoice ? 48 : (fontSizeIcon ? fontSizeIcon : 36)),
                        textAlign: 'center',
                        //alignSelf: 'flex-end',
                        color: container.state.onPressStatusVoice ? Colors.red : (colorIcon ? colorIcon : Colors.blackLight),
                        // width: moderateScale(32),
                        // height: moderateScale(32),
                        fontSize: moderateScale(container.state.onPressStatusVoice ? 48 : (fontSizeIcon ? fontSizeIcon : 36)),
                    }, styleIcon]}/>
                {
                    (showTime) ?

                        <HMTextView

                            // type={"bold"}

                            style={[{
                                fontSize: moderateScale(13),
                                color: Colors.blue,
                                //   margin: moderateScale(6)

                                // marginTop: moderateScale(10)
                            }, styleTime ? styleTime : {}]}
                            //text={Tools.getAudioTimeStringMin(this.state.currentTime)}
                            text={Tools.getAudioTimeStringMin(this.props.recorderControls.recordingTime)}
                            styleRoot={{}}
                        />

                        :
                        null
                }
            </TouchableOpacity>


        );
    }


    //
    // clearState() {
    //     container._setStateData()
    //     // descriptionValue = null;
    //     //
    //     // container.setState({
    //     //         showMessageInput: false,
    //     //         description: null,
    //     //         pathImage: null,
    //     //         pathVideo: null,
    //     //         ShowAudio: null,
    //     //
    //     //
    //     //         audioPath: null,
    //     //         audioBlob: null,
    //     //
    //     //
    //     //         listName: [],
    //     //         SelectRollValue: null,
    //     //         showSelectInputCCTask: false,
    //     //         showSelectInputRollBack: false,
    //     //         showSelectInputRoll: false,
    //     //     },
    //     //     () => {
    //     //     }
    //     // )
    // }

    startAudio = () => {
        // START: 'start',
        //     PAUSE: 'pause',
        //     STOP: 'stop',
        //     NONE: 'none'
        this.props.recorderControls.startRecording();
        container.setState({
            recordState: 'start',
            recording: true, paused: false,
        });
    };

    stopAudio = () => {
        this.recorderRef = this.props.recorderControls;
        this.props.recorderControls.stopRecording();
        container.setState({
            recordState: 'stop',
        });
    };

    //audioData contains blob and blobUrl
    onStopAudio = (audioData) => {
        /*

                // convert saved chunks to blob
               // const blob = audioData.blob;
                const blob = audioData.blob;
                // generate video url from blob
                //  const audioURL = window.URL.createObjectURL(blob);
                // append videoURL to list of saved videos for rendering
                // const audios = container.state.audios.concat([audioURL]);
                const audios = audioData.url;
                //   Tools.copyClipboardWeb(audios);
        */

        const blob = audioData;
        const audios = URL.createObjectURL(blob);
        /*  const audio = document.createElement("audio");

        audio.src = audios;
         audio.controls = true;
         document.body.appendChild(audio);*/
// console.log(container.props.recorderControls)
        container.setState({durationVoice: container.state.currentTime});
        container.props._setStateData({durationVoice: container.state.currentTime});
        container.props._setStateDataParent?.({durationVoice: container.state.currentTime});
        // container.setState({durationVoice: container.props.recorderControls.recordingTime});
        // container.props._setStateData({durationVoice: container.props.recorderControls.recordingTime});
        // container.props._setStateDataParent?.({durationVoice: container.props.recorderControls.recordingTime});

        let obj = {
            showMessageInput: true,

            audios, audioPath: audios, audioBlob: blob, ShowAudio: true,
            visibleModal: '', currentTime: 0,
            stoppedRecording: true, recording: false, paused: false,

        };
        container.props._setStateData?.(obj);
        container.props._setStateDataParent?.(obj);

        container.setState(obj,
            () => {
                container.props.onShow('selectaudio');
                // stream.getTracks().forEach(function (track) {
                //     track.stop();
                //     stream = null;
                // });
                //container.setData();
            },
        );
        // stream.getTracks().forEach(function (track) {
        //     track.stop();
        //     stream = null;
        // });
    };


}

/*const COMAllowanceClass = forwardRef((props, ref) => {
    console.log("ref", ref)

    const drawInfoBar = () => {
    }

    useImperativeHandle(ref, () => ({
        drawInfoBar: drawInfoBar
    }));
    const recorderControls = useAudioRecorder()
    return (<HMRecordAudio recorderControls={recorderControls} {...props} />);
});

const mapStateToProps = (state) => {

    return {
        DataSplashSatiaScreen: state.reducerSplashSatiaScreen,


    }
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(COMAllowanceClass);*/

const mapStateToProps = (state) => {

    return {
        DataSplashScreen: state.reducerSplashGetAllData,
    };
};
const mapDispatchToProps = dispatch => {
    return {};
};
const ConnectedMyComponent = connect(
    mapStateToProps, mapDispatchToProps,
)(HMRecordAudio);

export default forwardRef((props, ref) => {
        const inputRef = useRef(null);

        useImperativeHandle(ref, () => {
            return {
                _refreshAudio() {
                    _refreshAudio();
                },

            };
        }, []);
        // const _ref =  React.createRef(null);
        // const divRef = ref?.current ?? _ref;
        /*
           const  _refreshAudio=>() {
                let obj = {
                    ShowAudio: false,
                    currentTime: 0.0,
                    playSeconds: 0.0,
                    recording: false,
                    paused: false,
                    stoppedRecording: true,
                    finished: false,
                    // audioPath: AudioUtils.DocumentDirectoryPath +'/' +new Date().getTime()+'.aac',
                    //   audioPath: null,
                    //    hasPermission: undefined,


                    playState: 'record', //playing, paused ,record , stop
                    duration: 0

                };
                container.props._setStateData?.(obj)
                container.props._setStateDataParent?.(obj)
                container.setState(obj)

                //  container.props.func("audioPath", null)
                // container.props.func("ShowAudio", false)

            }*/

        const _refreshAudio = () => {
            container._refreshAudio();
        };
        return <ConnectedMyComponent

            {...props}
            _refreshAudio={_refreshAudio}
            ref={ref}
            // ref={(ref) => {
            //     console.log('@@@@@mnmnmn', ref);
            // }}
            recorderControls={useAudioRecorder()}
        />;
    },
);
/*
const mapStateToProps = (state) => {

    return {
        DataSplashScreen: state.reducerSplashGetAllData,
    }
}
const mapDispatchToProps = dispatch => {
    return {}
}
const connectAndForwardRef = (
    mapStateToProps = null,
    mapDispatchToProps = null,
    mergeProps = null,
    options = {},
) => component => connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
    {
        ...options,
        forwardRef: true,
    },
)(forwardRef(component));

export default  connectAndForwardRef(mapStateToProps, mapDispatchToProps)(HMRecordAudio)
*/

